import React, { useContext } from "react";
import VideoComponent from "../components/video1";
import { LanguageContext } from "../context/LanguageContext";
import WebHeader from "../components/web_header";
import Up from "../components/up";
import Chat from "../components/chat";

const GFORM_URL   = "https://docs.google.com/forms/d/e/1FAIpQLSd20rcu8gJTXN0faf7IfEYCV-5oqPFMzvD_RHayk19lCUdNig/viewform?usp=header";
const GFORM_EMBED = "https://docs.google.com/forms/d/e/1FAIpQLSd20rcu8gJTXN0faf7IfEYCV-5oqPFMzvD_RHayk19lCUdNig/viewform?embedded=true";

const DARK  = "rgb(46,46,46)";
const BLUE  = "rgb(37,71,122)";
const DARK2 = "rgba(0,0,0,0.22)";
const BLUE2 = "rgba(37,71,122,0.55)";
const TEXT_LIGHT = "rgb(198,198,198)";
const TEXT_BLUE  = "rgb(224,224,224)";

const sectionDark = { background: DARK, padding: "60px 24px", color: TEXT_LIGHT };
const sectionBlue = { background: BLUE, padding: "60px 24px", color: TEXT_BLUE };
const inner = { maxWidth: 960, margin: "0 auto", textAlign: "center" };
const cardGrid4 = { display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(200px,1fr))", gap: 20 };
const cardGrid7 = { display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(170px,1fr))", gap: 16 };

function LpCard({ title, text, bg }) {
  return (
    <div className="lp-card" style={{ background: bg, borderRadius: 10, padding: "24px 18px", height: "100%", textAlign: "center" }}>
      <h5 style={{ fontWeight: 700, marginBottom: 10, color: "#fff" }}>{title}</h5>
      <p style={{ margin: 0, opacity: 0.85, fontSize: 14 }}>{text}</p>
    </div>
  );
}

function WebP() {
  const { t } = useContext(LanguageContext);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  const probCards = [
    { title: t("lp_prob_c1_title"), text: t("lp_prob_c1_text") },
    { title: t("lp_prob_c2_title"), text: t("lp_prob_c2_text") },
    { title: t("lp_prob_c3_title"), text: t("lp_prob_c3_text") },
    { title: t("lp_prob_c4_title"), text: t("lp_prob_c4_text") },
  ];

  const howSteps = [
    { title: t("lp_how_s1_title"), text: t("lp_how_s1_text"), img: "/images/tt_instalation1.png" },
    { title: t("lp_how_s2_title"), text: t("lp_how_s2_text"), img: "/images/Techtalamo_context10.png" },
    { title: t("lp_how_s3_title"), text: t("lp_how_s3_text"), img: "/images/tt_showing.png" },
  ];

  const diagBlocks = [
    { title: t("lp_diag_b1_title"), text: t("lp_diag_b1_text") },
    { title: t("lp_diag_b2_title"), text: t("lp_diag_b2_text") },
    { title: t("lp_diag_b3_title"), text: t("lp_diag_b3_text") },
    { title: t("lp_diag_b4_title"), text: t("lp_diag_b4_text") },
  ];

  const solBenefits = [
    { title: t("lp_sol_b1_title"), text: t("lp_sol_b1_text") },
    { title: t("lp_sol_b2_title"), text: t("lp_sol_b2_text") },
    { title: t("lp_sol_b3_title"), text: t("lp_sol_b3_text") },
    { title: t("lp_sol_b4_title"), text: t("lp_sol_b4_text") },
  ];

  const measCards = [
    { title: t("lp_meas_c1_title"), text: t("lp_meas_c1_text"), img: "/images/tt_oper_prom.png" },
    { title: t("lp_meas_c5_title"), text: t("lp_meas_c5_text"), img: "/images/tt_seg_realtime.png" },
    { title: t("lp_meas_c6_title"), text: t("lp_meas_c6_text"), img: "/images/tt_conformidad.png" },
    { title: t("lp_meas_c7_title"), text: t("lp_meas_c7_text"), img: "/images/tt_oee.png" },
    { title: t("lp_meas_c2_title"), text: t("lp_meas_c2_text"), img: "/images/tt_t_no_prod.png" },
    { title: t("lp_meas_c3_title"), text: t("lp_meas_c3_text"), img: "/images/tt_eficiencia_lote.png" },
  ];

  const implSteps = [
    { title: t("lp_impl_s1_title"), text: t("lp_impl_s1_text"), img: "/images/impl_step1.png" },
    { title: t("lp_impl_s2_title"), text: t("lp_impl_s2_text"), img: "/images/impl_step2.png" },
    { title: t("lp_impl_s3_title"), text: t("lp_impl_s3_text"), img: "/images/impl_step3.png" },
    { title: t("lp_impl_s4_title"), text: t("lp_impl_s4_text"), img: "/images/impl_step4.png" },
    { title: t("lp_impl_s5_title"), text: t("lp_impl_s5_text"), img: "/images/impl_step5.png" },
  ];

  const badges = ["lp_co_badge1","lp_co_badge2","lp_co_badge3","lp_co_badge4","lp_co_badge5"];

  return (
    <>
      <div className="body">
        <WebHeader />
        <Up />

        {/* ── 1. HERO ─────────────────────────────────────────────── */}
        <section id="ahorro" style={{ position: "relative", minHeight: 460 }}>
          <img
            src="https://storage.googleapis.com/tt202501/images/Techtalamo_context1.png"
            alt="hero"
            style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", objectFit: "cover", display: "block" }}
          />
          <div style={{
            position: "relative", zIndex: 1,
            background: "rgba(20,42,80,0.78)",
            display: "flex", flexDirection: "column",
            alignItems: "center", justifyContent: "center",
            padding: "60px 24px",
            minHeight: 460,
          }}>
            <h1 style={{ color: "#fff", fontWeight: 800, textAlign: "center", maxWidth: 780, marginBottom: 18, lineHeight: 1.2 }}>
              {t("lp_hero_headline")}
            </h1>
            <p style={{ color: "rgb(198,218,255)", textAlign: "center", maxWidth: 680, fontSize: 16, marginBottom: 32, lineHeight: 1.6 }}>
              {t("lp_hero_sub")}
            </p>
            <div style={{ display: "flex", gap: 14, flexWrap: "wrap", justifyContent: "center" }}>
              <a href={GFORM_URL} target="_blank" rel="noopener noreferrer" className="btn btn-warning fw-bold px-4 py-2">
                {t("lp_hero_cta1")}
              </a>
              <button className="btn btn-outline-light px-4 py-2" onClick={() => scrollTo("como-funciona")}>
                {t("lp_hero_cta2")}
              </button>
            </div>
          </div>
        </section>

        {/* ── SOCIAL BANNER ───────────────────────────────────────── */}
        <div style={{
          background: "rgb(22,22,22)", borderBottom: "1px solid rgba(255,255,255,0.07)",
          padding: "10px 24px", display: "flex", justifyContent: "center", gap: 6,
        }}>
          {[
            { href: "https://www.instagram.com/techtalamo/", icon: "bi-instagram", label: "Instagram", color: "#e1306c" },
            { href: "https://www.facebook.com/search/top?q=techtalamo", icon: "bi-facebook", label: "Facebook", color: "#1877f2" },
            { href: "https://www.linkedin.com/company/107241130/admin/dashboard/", icon: "bi-linkedin", label: "LinkedIn", color: "#0a66c2" },
            { href: "https://www.youtube.com/@Techtalamo", icon: "bi-youtube", label: "YouTube", color: "#ff0000" },
          ].map(({ href, icon, label, color }) => (
            <a
              key={label}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              title={label}
              style={{
                display: "flex", alignItems: "center", justifyContent: "center",
                width: 36, height: 36, borderRadius: 6,
                color: "rgba(198,198,198,0.6)", textDecoration: "none",
                transition: "color 0.2s, background 0.2s",
              }}
              onMouseEnter={e => { e.currentTarget.style.color = color; e.currentTarget.style.background = "rgba(255,255,255,0.07)"; }}
              onMouseLeave={e => { e.currentTarget.style.color = "rgba(198,198,198,0.6)"; e.currentTarget.style.background = "transparent"; }}
            >
              <i className={`bi ${icon}`} style={{ fontSize: 18 }}></i>
            </a>
          ))}
        </div>

        {/* ── 2. PROBLEM ──────────────────────────────────────────── */}
        <section style={{ ...sectionDark, padding: 0 }}>
          <div className="prob-layout" style={{ display: "flex", alignItems: "stretch", maxWidth: "100%" }}>

            {/* Imagen izquierda — 1/3 */}
            <div className="prob-img" style={{ flex: "0 0 33.33%", maxWidth: "33.33%", minHeight: 400, overflow: "hidden" }}>
              <img
                src="/images/Checking_Data.png"
                alt="Checking Data"
                style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
              />
            </div>

            {/* Contenido derecho — 2/3 */}
            <div className="prob-content" style={{ flex: "0 0 66.66%", maxWidth: "66.66%", padding: "52px 40px" }}>
              <h2 style={{ color: "#fff", marginBottom: 16 }}>{t("lp_prob_title")}</h2>
              <p style={{ maxWidth: 640, marginBottom: 32, lineHeight: 1.7 }}>{t("lp_prob_text")}</p>
              <div className="prob-grid" style={{ display: "grid", gridTemplateColumns: "repeat(2,1fr)", gap: 16 }}>
                {probCards.map((c) => (
                  <LpCard key={c.title} title={c.title} text={c.text} bg={BLUE2} />
                ))}
              </div>
            </div>

          </div>
        </section>

        {/* ── 3. VALUE PROPOSITION ────────────────────────────────── */}
        <section style={{ ...sectionBlue, padding: 0 }}>
          <div className="val-layout" style={{ display: "flex", alignItems: "stretch", maxWidth: "100%" }}>

            {/* Contenido izquierdo — 2/3 */}
            <div className="val-content" style={{ flex: "0 0 66.66%", maxWidth: "66.66%", padding: "52px 40px", display: "flex", flexDirection: "column", justifyContent: "center" }}>
              <h2 style={{ color: "#fff", marginBottom: 20 }}>{t("lp_value_title")}</h2>
              <p style={{ fontSize: 16, lineHeight: 1.8, margin: 0 }}>{t("lp_value_text")}</p>
            </div>

            {/* Imagen derecha — 1/3 */}
            <div className="val-img" style={{ flex: "0 0 33.33%", maxWidth: "33.33%", minHeight: 320, overflow: "hidden" }}>
              <img
                src="/images/machine1.png"
                alt="Machine data"
                style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
              />
            </div>

          </div>
        </section>

        {/* ── 4. HOW IT WORKS ─────────────────────────────────────── */}
        <section id="como-funciona" style={sectionDark}>
          <div style={inner}>
            <h2 style={{ color: "#fff", marginBottom: 12 }}>{t("lp_how_title")}</h2>
            <p style={{ maxWidth: 680, margin: "0 auto 40px" }}>{t("lp_how_intro")}</p>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(240px,1fr))", gap: 20, marginBottom: 44 }}>
              {howSteps.map((s) => (
                <div key={s.title} className="lp-card" style={{ background: BLUE2, borderRadius: 10, overflow: "hidden", textAlign: "center" }}>
                  <div style={{ padding: "24px 18px 16px" }}>
                    <h5 style={{ fontWeight: 700, marginBottom: 0, color: "#fff" }}>{s.title}</h5>
                  </div>
                  <div style={{ background: "rgba(0,0,0,0.25)", minHeight: 160 }}>
                    {s.img && (
                      <img
                        src={s.img}
                        alt={s.title}
                        style={{ width: "100%", display: "block", objectFit: "cover", maxHeight: 200 }}
                      />
                    )}
                  </div>
                  <div style={{ padding: "16px 18px 24px" }}>
                    <p style={{ margin: 0, opacity: 0.85, fontSize: 14 }}>{s.text}</p>
                  </div>
                </div>
              ))}
            </div>
            <div style={{ overflow: "hidden", borderRadius: 8, background: "rgba(0,0,0,0.25)", padding: 12 }}>
              <VideoComponent />
            </div>
          </div>
        </section>

        {/* ── 5. DIAGNOSIS ────────────────────────────────────────── */}
        <section id="diagnostico" style={sectionBlue}>
          <div style={inner}>
            <h2 style={{ color: "#fff", marginBottom: 16 }}>{t("lp_diag_title")}</h2>
            <p style={{ maxWidth: 720, margin: "0 auto 40px", lineHeight: 1.7 }}>{t("lp_diag_text")}</p>
            <div style={{ ...cardGrid4, marginBottom: 36 }}>
              {diagBlocks.map((b) => (
                <LpCard key={b.title} title={b.title} text={b.text} bg={DARK2} />
              ))}
            </div>
            <a href={GFORM_URL} target="_blank" rel="noopener noreferrer" className="btn btn-warning fw-bold px-5 py-2">
              {t("lp_diag_cta")}
            </a>
          </div>
        </section>

        {/* ── 6. PROCESS SENSING ──────────────────────────────────── */}
        <section id="proceso" style={sectionDark}>
          <div style={inner}>
            <img
              src="https://storage.googleapis.com/tt202501/images/Techtalamo_context11.png"
              alt="process sensing"
              style={{ width: "100%", maxHeight: 240, objectFit: "cover", borderRadius: 8, marginBottom: 36 }}
            />
            <h2 style={{ color: "#fff", marginBottom: 16 }}>{t("lp_sol_title")}</h2>
            <p style={{ maxWidth: 720, margin: "0 auto 40px", lineHeight: 1.7 }}>{t("lp_sol_text")}</p>
            <div style={cardGrid4}>
              {solBenefits.map((b) => (
                <LpCard key={b.title} title={b.title} text={b.text} bg={BLUE2} />
              ))}
            </div>
          </div>
        </section>

        {/* ── 7. WHAT YOU CAN MEASURE ─────────────────────────────── */}
        <section style={sectionBlue}>
          <div style={{ ...inner, maxWidth: 1100 }}>
            <h2 style={{ color: "#fff", marginBottom: 16 }}>{t("lp_meas_title")}</h2>
            <p style={{ maxWidth: 760, margin: "0 auto 36px", lineHeight: 1.7, opacity: 0.85 }}>{t("lp_meas_intro")}</p>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 16 }}>
              {measCards.map((c) => (
                <div key={c.title} className="lp-card" style={{
                  display: "flex", alignItems: "stretch", overflow: "hidden",
                  background: DARK2, borderRadius: 10,
                }}>
                  <div style={{ width: "66.66%", flexShrink: 0, background: "rgba(0,0,0,0.3)" }}>
                    {c.img && (
                      <img
                        src={c.img}
                        alt={c.title}
                        style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
                      />
                    )}
                  </div>
                  <div style={{ width: "33.33%", padding: "20px 16px", display: "flex", flexDirection: "column", justifyContent: "center" }}>
                    <h5 style={{ fontWeight: 700, marginBottom: 8, color: "#fff" }}>{c.title}</h5>
                    <p style={{ margin: 0, opacity: 0.85, fontSize: 13, lineHeight: 1.6 }}>{c.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ── 8. ECONOMIC IMPACT ──────────────────────────────────── */}
        <section style={sectionDark}>
          <div style={{ ...inner, maxWidth: 820 }}>
            <h2 style={{ color: "#fff", marginBottom: 16 }}>{t("lp_econ_title")}</h2>
            <p style={{ maxWidth: 680, margin: "0 auto 36px", lineHeight: 1.7 }}>{t("lp_econ_text")}</p>
            <div style={{
              background: BLUE2, borderRadius: 12, padding: "32px 28px",
              maxWidth: 480, margin: "0 auto 36px",
              border: "1px solid rgba(255,255,255,0.12)",
            }}>
              <p style={{ fontSize: 14, opacity: 0.8, marginBottom: 6 }}>{t("lp_econ_calc_line1")}</p>
              <p style={{ fontSize: 22, fontWeight: 700, color: "#f59e0b", margin: "0 0 16px" }}>{t("lp_econ_calc_line2")}</p>
              <hr style={{ borderColor: "rgba(255,255,255,0.2)" }} />
              <p style={{ fontSize: 18, fontWeight: 700, color: "#fff", marginBottom: 8 }}>{t("lp_econ_calc_result")}</p>
              <p style={{ fontSize: 14, fontStyle: "italic", opacity: 0.75, marginBottom: 0 }}>{t("lp_econ_calc_question")}</p>
            </div>
            <a href={GFORM_URL} target="_blank" rel="noopener noreferrer" className="btn btn-warning fw-bold px-5 py-2">
              {t("lp_econ_cta")}
            </a>
          </div>
        </section>

        {/* ── 9. IMPLEMENTATION ───────────────────────────────────── */}
        <section style={sectionBlue}>
          <div style={{ ...inner, maxWidth: 960 }}>
            <h2 style={{ color: "#fff", marginBottom: 12 }}>{t("lp_impl_title")}</h2>
            <p style={{ maxWidth: 680, margin: "0 auto 40px", lineHeight: 1.7 }}>{t("lp_impl_text")}</p>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(380px, 1fr))", gap: 14 }}>
              {implSteps.map((s) => (
                <div key={s.title} className="lp-card" style={{
                  display: "flex", alignItems: "stretch", overflow: "hidden",
                  background: DARK2, borderRadius: 10, textAlign: "left",
                }}>
                  <img
                    src={s.img}
                    alt={s.title}
                    style={{ width: "40%", minHeight: 160, objectFit: "cover", display: "block", flexShrink: 0 }}
                  />
                  <div style={{ flex: 1, padding: "22px 20px", display: "flex", flexDirection: "column", justifyContent: "center" }}>
                    <h6 style={{ fontWeight: 700, marginBottom: 6, color: "#fff", fontSize: 15 }}>{s.title}</h6>
                    <p style={{ margin: 0, opacity: 0.85, fontSize: 13, lineHeight: 1.6 }}>{s.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ── 10. COMPANY ─────────────────────────────────────────── */}
        <section id="compania" style={sectionDark}>
          <div style={{ ...inner, maxWidth: 900 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 32, flexWrap: "wrap", justifyContent: "center", marginBottom: 36 }}>
              <img
                src="https://storage.googleapis.com/tt202501/images/Techtalamo_context13.png"
                alt="company"
                style={{ maxHeight: 200, maxWidth: 260, objectFit: "contain", borderRadius: 8 }}
              />
              <div style={{ flex: 1, minWidth: 280, textAlign: "left" }}>
                <h2 style={{ color: "#fff", marginBottom: 14 }}>{t("lp_co_title")}</h2>
                <p style={{ lineHeight: 1.7 }}>{t("lp_co_text")}</p>
              </div>
            </div>
            <div style={{ display: "flex", gap: 10, flexWrap: "wrap", justifyContent: "center" }}>
              {badges.map((k) => (
                <span key={k} style={{
                  background: BLUE2, color: TEXT_BLUE,
                  borderRadius: 20, padding: "6px 18px", fontSize: 13,
                  border: "1px solid rgba(255,255,255,0.15)",
                }}>{t(k)}</span>
              ))}
            </div>
          </div>
        </section>

        {/* ── 11. FINAL CTA ───────────────────────────────────────── */}
        <section id="contacto" style={sectionBlue}>
          <div style={{ ...inner, maxWidth: 740 }}>
            <h2 style={{ color: "#fff", marginBottom: 18 }}>{t("lp_cta_title")}</h2>
            <p style={{ maxWidth: 640, margin: "0 auto 32px", lineHeight: 1.7 }}>{t("lp_cta_text")}</p>
            <a href={GFORM_URL} target="_blank" rel="noopener noreferrer" className="btn btn-warning fw-bold px-5 py-2 mb-3">
              {t("lp_cta_btn")}
            </a>
            <p style={{ opacity: 0.7, fontSize: 14, marginTop: 8 }}>
              {t("lp_cta_secondary")}{" "}
              <a href="mailto:info@techtalamo.com" style={{ color: "#f59e0b" }}>info@techtalamo.com</a>
            </p>
            <iframe
              src={GFORM_EMBED}
              title="TECHTALAMO Contact Form"
              width="100%"
              height="320"
              frameBorder="0"
              marginHeight="0"
              marginWidth="0"
              style={{ borderRadius: 8, display: "block", marginTop: 32 }}
            >
              Loading…
            </iframe>
          </div>
          <Chat />
        </section>

        {/* ── 12. OTHER PRODUCTS ──────────────────────────────────── */}
        <section id="otros-productos" style={{ background: "rgb(28,28,28)", padding: "52px 24px", color: TEXT_LIGHT }}>
          <div style={{ ...inner, maxWidth: 860 }}>
            <h2 style={{ color: "#fff", marginBottom: 16 }}>{t("lp_other_title")}</h2>
            <p style={{ maxWidth: 680, margin: "0 auto 36px", lineHeight: 1.7 }}>{t("lp_other_subtitle")}</p>

            {/* Tarjeta Read2Data */}
            <div className="lp-card" style={{
              display: "flex", alignItems: "stretch", gap: 0, overflow: "hidden",
              background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.1)",
              borderRadius: 12,
            }}>
              <img
                src="/images/op_r2d.png"
                alt="Read2Data"
                style={{ flex: 1, minWidth: 0, objectFit: "cover" }}
              />
              <div style={{ display: "flex", alignItems: "center", gap: 20, flexWrap: "wrap", padding: "24px 28px", flex: 1 }}>
                <div style={{ flex: 1, minWidth: 220, textAlign: "left" }}>
                  <h4 style={{ color: "#fff", fontWeight: 700, marginBottom: 10 }}>{t("lp_other_r2d_title")}</h4>
                  <p style={{ opacity: 0.8, lineHeight: 1.7, marginBottom: 0, fontSize: 14 }}>{t("lp_other_r2d_text")}</p>
                </div>
                <a
                  href="https://www.read2data.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-outline-light px-4 py-2"
                  style={{ whiteSpace: "nowrap", flexShrink: 0 }}
                >
                  {t("lp_other_r2d_cta")} →
                </a>
              </div>
            </div>

          </div>
        </section>

      </div>
    </>
  );
}

export default WebP;
